import { render } from "./ListeTypeContainerPage.vue?vue&type=template&id=0beea55a&ts=true"
import script from "./ListeTypeContainerPage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeContainerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__